import { inject } from 'aurelia-framework';
import { BrowserDetectionService } from './browser-detection-service';

@inject(BrowserDetectionService)
export class BrowserStorageService {
    constructor(browserDetection) {
        this.browserDetection = browserDetection;
    }

    getItem(key) {
        if (this.browserDetection.isIE) {
            return window.sessionStorage.getItem(key);
        } else {
            return window.localStorage.getItem(key);
        }
    }

    setItem(key, val) {
        if (this.browserDetection.isIE) {
            window.sessionStorage.setItem(key, val);
        } else {
            window.localStorage.setItem(key, val);
        }
    }

    removeItem(key) {
        if (this.browserDetection.isIE) {
            window.sessionStorage.removeItem(key);
        } else {
            window.localStorage.removeItem(key);
        }
    }

    get storage() {
        if (this.browserDetection.isIE) {
            return window.sessionStorage;
        } else {
            return window.localStorage;
        }
    }
}
